import { NotificationService } from '@aiz-gl/omni-ui';
import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

export function errorInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  const notifications = inject(NotificationService);

  return next(req).pipe(
    catchError((response: HttpErrorResponse) => {
      const { status, error } = response;
      const normalizedUrl = req.url.toLowerCase();
      const isRmaMutationEndpoint =
        req.method === 'POST' &&
        /(^|\/)rma(\/[^/?]+)?(\/decision|\/resubmit|\/attachments)?\/?(?:\?|$)/i.test(
          normalizedUrl,
        );
      const isOrderDevicesEndpoint =
        normalizedUrl.includes('orderhistory/details') ||
        normalizedUrl.includes('orderhistory/orderdevices') ||
        normalizedUrl.includes('orderdevices');
      const isRmaByAtbOrderNotFound =
        status === 404 && normalizedUrl.includes('rma/by-atb-order');

      const payloadMessage =
        typeof error === 'string'
          ? error
          : error && typeof error === 'object' && 'message' in error && typeof error.message === 'string'
            ? error.message
            : '';
      const isOrderDevicesNotFoundMessage = /order\s*history\s*details\s*not\s*found/i.test(payloadMessage);
      const isOrderDevicesNotFound =
        (status === 404 && isOrderDevicesEndpoint) ||
        (isOrderDevicesEndpoint && isOrderDevicesNotFoundMessage);

      if ([422, 409].includes(status)) {
        return throwError(() => response);
      }

      if (isOrderDevicesNotFound || isRmaByAtbOrderNotFound) {
        return throwError(() => response);
      }

      let parsedMessage = '';

      if (typeof error === 'string' && error.trim().length > 0) {
        parsedMessage = error;
      } else if (error && typeof error === 'object') {
        if ('error' in error && typeof error.error === 'string' && error.error.trim().length > 0) {
          parsedMessage = error.error;
        } else if (
          'message' in error &&
          typeof error.message === 'string' &&
          error.message.trim().length > 0
        ) {
          parsedMessage = error.message;
        }
      }

      if (!parsedMessage && response.message) {
        parsedMessage = response.message;
      }

      const errorMessage = `${parsedMessage || 'Request failed'} (code: ${status})`;

      if (!(isRmaMutationEndpoint && [401, 403].includes(status))) {
        notifications.showAlert({
          variant: 'warn',
          symbolName: 'report',
          message: errorMessage,
        });
      }

      return throwError(() => response);
    }),
  );
}
